/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Button,
  Grid,
  Breadcrumbs,
  Link,
  Typography,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  CircularProgress,
  Backdrop
} from "@material-ui/core";
import "date-fns";
//icons
import EqualizerIcon from "@material-ui/icons/Equalizer";
import PrintIcon from "@material-ui/icons/Print";

// components
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import Table from "./components/Table/Table";
//context
import { useVendorState } from "../../context/VendorContext";

//helpers
import { fetchCompetitionSalesByASIN, fetchPriceWarRanges } from "../../http/api";

import useStyles from "./styles";

export default function Charts(props) {
  const exportFunctionRef = useRef();
  //global
  const classes = useStyles();
  var vendorState = useVendorState();

  // local
  const [dateRange, setDateRange] = useState([]);
  const [mainTableData, setmainTableData] = useState([]);
  const [selectedInterval, setSelectedInterval] = useState('');
  const [segments, setSegments] = useState([]);
  const [selectedSegment, setSelectedSegment] = useState('');
  const [fullPageLoader, setfullPageLoader] = useState(false);

  useEffect(() => {
    fetchPriceWarRanges(vendorState?.selected)
      .then(({ intervals, segments }) => {

        setDateRange(intervals?.reverse());
        setSelectedInterval(intervals?.[0]);
        setSegments(segments);
        setSelectedSegment(segments?.[0]?.id || '');
      }).catch((err) => {
        console.error('Failed to fetch the ranges')
      })

    return () => {
      setDateRange([]);
      setSelectedInterval('')
    }
  }, [vendorState?.selected])

  useEffect(() => {
    async function fetchData() {
      try {

        setfullPageLoader(true);
        const { filteredData } = await fetchCompetitionSalesByASIN(vendorState?.selected, selectedInterval, selectedSegment)
        setmainTableData(filteredData);

      } catch (error) {
        console.error(error);
      } finally {
        setfullPageLoader(false);
      }
    }

    if (selectedInterval && selectedSegment) {
      fetchData();
    }

    return () => {
      setmainTableData([]);
    };

  }, [vendorState?.selected, selectedInterval, selectedSegment]);

  return (
    <>
      <Container maxWidth={false}>
        <PageTitle
          title="Competition Detailed Sales"
          breadCrump={
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                color="inherit"
                // href="/#/app/dashboard"
                className={classes.link}
              >
                <EqualizerIcon className={classes.icon} />
                Business Intelligence
              </Link>
              <Typography className={classes.link}>
                <EqualizerIcon color="primary" className={classes.icon} />
                Competition Sales By ASIN
              </Typography>
            </Breadcrumbs>
          }
          rightAlignComponent={
            <>
              <FormControl variant="outlined" className={classes.campaignControl}>
                <InputLabel id="demo-simple-select-outlined-label">
                  Select Interval
                </InputLabel>
                <Select
                  value={selectedInterval}
                  onChange={(e) => {
                    setSelectedInterval(e.target.value);
                  }}
                  label="Select Interval"
                  disabled={dateRange && dateRange.length === 0 ? true : false}
                >
                  {dateRange && dateRange.length ? (
                    dateRange.map((range, index) => {
                      return (
                        <MenuItem value={range}>
                          {range}
                        </MenuItem>
                      );
                    })
                  ) : (
                    <MenuItem value={0}>
                      <i>No Dates</i>
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
              <FormControl variant="outlined" className={classes.campaignControl}>
                <InputLabel id="demo-simple-select-outlined-label">
                  Select Segment
                </InputLabel>
                <Select
                  value={selectedSegment}
                  onChange={(e) => {
                    setSelectedSegment(e.target.value);
                  }}
                  label="Select Segment"
                  disabled={segments && segments.length === 0 ? true : false}
                >
                  {segments && segments.length ? (
                    segments.map((segment, index) => {
                      return (
                        <MenuItem value={segment?.id}>
                          {segment?.name}
                        </MenuItem>
                      );
                    })
                  ) : (
                    <MenuItem value={0}>
                      <i>No Segments</i>
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </>
          }
        />
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Widget
              upperTitle
              noBodyPadding
              bodyClass={classes.tableOverflow}
              header={
                <div className={classes.mainChartHeader}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<PrintIcon />}
                    onClick={() => exportFunctionRef.current.onBtnExport()}
                  >
                    Export
                  </Button>
                </div>
              }
            >
              <Table ref={exportFunctionRef} tableData={mainTableData} />
            </Widget>
          </Grid>
        </Grid>
        <Backdrop
          className={classes.backdrop}
          open={fullPageLoader}
        // onClick={() => setfullPageLoader(false)}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>
    </>
  );
}
